// Tracks which single keyboard-driven selection "region" is currently active
// (e.g. the Feeds sidebar vs. one source row on the Feeds page) so that
// interacting with one clears the other's selection and stops routing
// keystrokes to it. Generic on purpose — not Feeds-specific — so any other
// selection-driven surface (e.g. a future calendar/task multi-select) can
// register itself the same way.
import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

interface ActiveRegionValue {
  active: string | null;
  setActive: (id: string | null) => void;
}

const ActiveRegionContext = createContext<ActiveRegionValue | null>(null);

export function ActiveRegionProvider({ children }: { children: ReactNode }) {
  const [active, setActive] = useState<string | null>(null);
  const value = useMemo(() => ({ active, setActive }), [active]);
  return <ActiveRegionContext.Provider value={value}>{children}</ActiveRegionContext.Provider>;
}

export function useActiveRegion(): ActiveRegionValue {
  const ctx = useContext(ActiveRegionContext);
  if (!ctx) throw new Error("useActiveRegion must be used within an ActiveRegionProvider");
  return ctx;
}
